///include /assets/js/app/p/checkout.js
class CheckoutPaddleBilling extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }

    /**
     * Opens Paddle Checkout (Paddle.js v2) for an invoice transaction.
     *
     * The payment service creates the Paddle transaction, so the amount never
     * comes from the browser. On completion, the Paddle transaction ID is
     * handed back to be posted to /preauthv2, where the payment service checks
     * it with Paddle before accepting it.
     *
     * @param {{
     *  invoiceId: string,
     *  transactionId: string,
     *  info: {clientToken: string, isEffectivelyLive: boolean},
     *  customer: {email: ?string, countryCode: ?string, postalCode: ?string},
     *  onCompleted: (paddleTransactionId: string) => void,
     *  onClosed: () => void,
     * }} options
     * @returns {Promise<void>}
     */
    static async openCheckout(options) {
        /** @type {{transactionId: string, recurring: boolean}} */
        const checkout = await $.ajax(`/n/invoice/v2/${options.invoiceId}/transaction/${options.transactionId}/getPaddleBillingCheckout`)
        if(!checkout || !checkout.transactionId) {
            throw new Error("No Paddle transaction was created")
        }

        await Site.require_once("https://cdn.paddle.com/paddle/v2/paddle.js")

        let completed = false
        // Paddle.js may only be initialised once per page, so the callback
        // it's given dispatches to whichever checkout is open now.
        CheckoutPaddleBilling.onEvent = event => {
            switch(event.name) {
                case "checkout.completed":
                    completed = true
                    //@ts-ignore
                    Paddle.Checkout.close()
                    options.onCompleted(event.data.transaction_id)
                    break
                case "checkout.closed":
                    if(!completed) {
                        options.onClosed()
                    }
                    break
                default:
                    // Other events (eg. payment attempts) need no action
            }
        }
        if(!CheckoutPaddleBilling.initialised) {
            if(!options.info.isEffectivelyLive) {
                //@ts-ignore
                Paddle.Environment.set("sandbox")
            }
            //@ts-ignore
            Paddle.Initialize({
                token: options.info.clientToken,
                eventCallback: event => CheckoutPaddleBilling.onEvent(event),
            })
            CheckoutPaddleBilling.initialised = true
        }

        const address = {}
        if(options.customer.countryCode) {
            address.countryCode = options.customer.countryCode
            if(options.customer.postalCode) {
                address.postalCode = options.customer.postalCode
            }
        }
        //@ts-ignore
        Paddle.Checkout.open({
            transactionId: checkout.transactionId,
            customer: Object.assign(
                options.customer.email ? {email: options.customer.email} : {},
                address.countryCode ? {address} : {}
            ),
            settings: {
                displayMode: "overlay",
                allowLogout: false,
                showAddDiscounts: false,
            },
        })
    }
}

/** @type {boolean} */
CheckoutPaddleBilling.initialised = false
/** @type {(event: {name: string, data: *}) => void} */
CheckoutPaddleBilling.onEvent = () => {}

CheckoutDriver.byName.paddlebilling = CheckoutPaddleBilling
